const actions = {
  FETCH_EXTERNAL_TICKET_SERVICE_CODES: 'FETCH_EXTERNAL_TICKET_SERVICE_CODES',
  FETCH_EXTERNAL_TICKET_SERVICE_CODES_ENDED: 'FETCH_EXTERNAL_TICKET_SERVICE_CODES_ENDED',
  FETCH_EXTERNAL_TICKET_LISTS: 'FETCH_EXTERNAL_TICKET_LISTS',
  FETCH_EXTERNAL_TICKET_LISTS_ENDED: 'FETCH_EXTERNAL_TICKET_LISTS_ENDED',

  CREATE_EXTERNAL_TICKET: 'CREATE_EXTERNAL_TICKET',
  CREATE_EXTERNAL_TICKET_ENDED: 'CREATE_EXTERNAL_TICKET_ENDED',
  SEARCH_EXTERNAL_TICKETS: 'SEARCH_EXTERNAL_TICKETS',
  SEARCH_EXTERNAL_TICKETS_ENDED: 'SEARCH_EXTERNAL_TICKETS_ENDED',
  UPDATE_EXTERNAL_TICKET: 'UPDATE_EXTERNAL_TICKET',
  UPDATE_EXTERNAL_TICKET_ENDED: 'UPDATE_EXTERNAL_TICKET_ENDED',

  SEARCH_EXTERNAL_TICKET_ISSUED_RECORDS: 'SEARCH_EXTERNAL_TICKET_ISSUED_RECORDS',
  SEARCH_EXTERNAL_TICKET_ISSUED_RECORDS_ENDED: 'SEARCH_EXTERNAL_TICKET_ISSUED_RECORDS_ENDED',
};

export default actions;
